// @flow
import { connect, Provider } from 'react-redux';

import type { DiamondType } from '@types/diamond';
import type { TFavoriteSetting } from '@types/setting';
import type { RailsContextType, ObjectType } from '@types/misc';

import LegacyComparisonGrid from '@components/diamond_comparison/LegacyComparisonGrid';

type PropsType = {
  onNameClick: (N: string) => void,
  onRemoveClick: (ID: string) => void,
  diamonds: Array<DiamondType>,
  settings: Array<TFavoriteSetting>,
  sortColumn: string | null,
  sortDirection: string | null,
  loggedIn: boolean
};

function mapStateToProps(state) {
  return {
    diamonds: state.diamondComparison.diamonds,
    settings: state.settingFavorites.settings,
    sortColumn: state.diamondComparison.sortColumn,
    sortDirection: state.diamondComparison.sortDirection
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onNameClick: function(name) {
      dispatch({ type: 'SORT_DIAMOND_COMPARISON', column: name });
    },
    onRemoveDiamondClick: function(diamondId: string) {
      dispatch({ type: 'TOGGLE_DIAMOND_FOR_COMPARISON', item: diamondId });
    }
  };
}

const LegacyComparisonGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LegacyComparisonGrid);

export default (props: PropsType, railsContext: RailsContextType) => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <LegacyComparisonGridContainer {...{ ...props, railsContext }} />
    </Provider>
  );
};
